module.exports = __webpack_public_path__ + "images/146_1024.jpg";